import React from "react";

import { Transaction } from "../../common/types/transaction";
import { Button } from "../general/Button/Button";
import { dateFormatter } from "../../common/helpers/date";
import { currencyFormatter } from "../../common/helpers/currency";

interface SoftDeletedTransactionToastProps {
    transaction: Transaction;
    undo: () => void;
}

export const createTransactionDescription = (
    transaction: Transaction,
): string => {
    const { amount, memo, bankDescription, date } = transaction;
    const dateString = dateFormatter.format(date);
    const amountString = currencyFormatter.format(amount);
    return `${amountString} - ${bankDescription ?? memo} on ${dateString}`;
};

export const SoftDeletedTransactionToast: React.FC<
    SoftDeletedTransactionToastProps
> = ({ transaction, undo }) => (
    <div className="d-flex mr-4 justify-content-between">
        <div>
            <p>
                Transaction "{createTransactionDescription(transaction)}" has
                been deleted.
            </p>
        </div>
        <div style={{ flexShrink: 0 }}>
            <Button variant="secondary" onClick={() => undo()}>
                Undo
            </Button>
        </div>
    </div>
);
